<div class="box">
    <div class="box-content">
        <mat-icon color="primary">info_outline</mat-icon>
    </div>
    <div class="box-content"
         translate>
        robot_settings_info_box_message
    </div>
</div>
<form [formGroup]="form">

    <label [id]="robotTypeId"
           translate>
        provision_robot_license_type
    </label>
    <mat-radio-group [formControlName]="RobotFormControl.type"
                     [attr.aria-labelledby]="robotTypeId"
                     class="robot-type-group">
        <mat-radio-button *ngIf="userType === UserType.DirectoryUser"
                          [value]="null"
                          class="robot-type-entry">
            {{ 'provision_robot_license_type_inherit' | translate }}
        </mat-radio-button>
        <mat-radio-button *ngFor="let type of typeList"
                          [value]="type.value"
                          class="robot-type-entry">
            {{ type.translationKey | translate }}
            <em *ngIf="form.get(RobotFormControl.type).value === type.value &&
                [RobotTypeAttended.Development, RobotTypeAttended.StudioX].includes(type.value)"
                class="development-robots-warning">&ndash;
                <span translate>robot_settings_development_robots_warning</span></em>
        </mat-radio-button>
    </mat-radio-group>

    <div class="robot-options">
        <ng-container *ngIf="[RobotTypeAttended.Development, RobotTypeAttended.StudioX]
                            .includes(form.get(RobotFormControl.type)!.value)">
            <mat-checkbox [formControlName]="RobotFormControl.isExternalLicensed">
                {{ 'robot_modal_form_isExternalLicense' | translate}}
            </mat-checkbox>
        </ng-container>
    </div>

    <ng-container *ngIf="userType === UserType.User">
        <mat-form-field *ngLet="form.get(RobotFormControl.userName) as usernameField">
            <input [formControlName]="RobotFormControl.userName"
                   [placeholder]="'robot_modal_form_username' | translate"
                   [required]="userType === UserType.User"
                   matInput
                   uiPreventAutofill
                   data-cy="robot-username" />
            <mat-error *ngIf="usernameField.hasError('maxlength')"
                       [translateParams]="{
                              max: usernameField.getError('maxlength').requiredLength
                       }"
                       translate>
                robot_modal_form_username_max_warning
            </mat-error>
            <mat-error *ngIf="!usernameField.hasError('maxlength') &&
                               usernameField.hasError('regex')"
                       translate>
                robot_modal_form_username_floating_pattern
            </mat-error>
        </mat-form-field>

    </ng-container>

    <section *ngIf="hasExecutionSettings"
             data-cy="robot-execution-settings">
        <ng-container *ngLet="executionSettingsConfig$ | async as executionSettingsConfig">
            <div *uiContentLoading="!executionSettingsConfig">
                <ng-container *ngIf="executionSettingsConfig?.length">
                    <label translate>
                        provision_robot_execution_settings
                    </label>
                    <ui-execution-settings [disabled]="!enabled"
                                           [settingsConfig]="executionSettingsConfig"
                                           [settingsValues]="robot && robot!.executionSettings || {}">
                    </ui-execution-settings>
                </ng-container>
            </div>
        </ng-container>
    </section>
</form>
